(() => {
  const initialiseFaq = (root) => {
    if (!root || root.dataset.faqInitialised === 'true') return;

    const search = root.querySelector('[data-faq-search]');
    const categoryButtons = Array.from(root.querySelectorAll('[data-faq-category]'));
    const sections = Array.from(root.querySelectorAll('[data-faq-section]'));
    const noResults = root.querySelector('[data-faq-no-results]');
    let activeCategory = 'all';

    const normalise = (value) => value.toLowerCase().replace(/\s+/g, ' ').trim();

    const filterFaqs = () => {
      const query = normalise(search ? search.value : '');
      let visibleCount = 0;

      sections.forEach((section) => {
        const categoryMatches =
          activeCategory === 'all' || section.dataset.faqSection === activeCategory;
        let sectionVisibleCount = 0;

        section.querySelectorAll('[data-faq-item]').forEach((item) => {
          const queryMatches = query === '' || normalise(item.textContent).includes(query);
          const isVisible = categoryMatches && queryMatches;

          item.hidden = !isVisible;
          if (!isVisible) item.open = false;
          if (isVisible) {
            sectionVisibleCount += 1;
            visibleCount += 1;
          }
        });

        section.hidden = sectionVisibleCount === 0;
      });

      if (noResults) noResults.hidden = visibleCount !== 0;
    };

    categoryButtons.forEach((button) => {
      button.addEventListener('click', () => {
        activeCategory = button.dataset.faqCategory || 'all';

        categoryButtons.forEach((categoryButton) => {
          const isActive = categoryButton === button;
          categoryButton.classList.toggle('is-active', isActive);
          categoryButton.setAttribute('aria-pressed', String(isActive));
        });

        filterFaqs();
      });
    });

    if (search) search.addEventListener('input', filterFaqs);

    root.dataset.faqInitialised = 'true';
    filterFaqs();
  };

  const initialiseAllFaqs = (scope = document) => {
    scope.querySelectorAll('[data-zwc-faq]').forEach(initialiseFaq);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAllFaqs());
  } else {
    initialiseAllFaqs();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initialiseAllFaqs(event.target);
  });
})();

